export const COLUMNS = {
  TODAY: 'today',
  TOMORROW: 'tomorrow',
  LATER: 'later',
} as const

export type ColumnsType = typeof COLUMNS
export type ColumnValues = ColumnsType[keyof ColumnsType]
